/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IWard } from 'app/shared/model/ward.model';
import { RoomType } from 'app/shared/model/enumerations/room-type.model';

export interface IRoom {
  id?: string;
  name?: string | null;
  roomNumber?: string | null;
  tempClosed?: boolean | null;
  dateClosed?: number | null;
  description?: string | null;
  bedNoStart?: number | null;
  bedNoEnd?: number | null;
  bedPrefix?: string | null;
  modifiedBy?: string | null;
  modifiedTime?: number | null;
  createdBy?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  roomType?: keyof typeof RoomType | null;
  ward?: IWard | null;
}

export const defaultValue: Readonly<IRoom> = {
  tempClosed: false,
  active: false,
};
